/**
 * UPMP web-customer entry — bootstraps React Query, Router, and Tailwind.
 *
 * Phase-2 scope: a public, no-auth tracking lookup page. Authenticated
 * customer flows (service-identity login per MONOREPO.md §8) land in a
 * separate slice; this entry deliberately does NOT mount any auth provider.
 */
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { queryClient } from './lib/queryClient';

import './styles/tailwind.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('UPMP: #root element missing in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
